// src/firebaseConfig.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
  getAuth,
  browserLocalPersistence,
  setPersistence,
  onAuthStateChanged,
} from "firebase/auth";
import { getStorage } from "firebase/storage";

import { getFunctions } from "firebase/functions";

/* ---------------- FIREBASE CONFIG ---------------- */
const firebaseConfig = {
  apiKey: "AIzaSyBXecn8iJkN55hhFPpHXOB017J6-3pALBw",
  authDomain: "shineagrimscs.firebaseapp.com",
  projectId: "shineagrimscs",

  // ✅ Correct Bucket Format 
   storageBucket: "shineagrimscs.firebasestorage.app",


  messagingSenderId: "1097268595917",
  appId: "1:1097268595917:web:1f4d8310bd567062e46d84",
  measurementId: "G-S6N2SL23K9",
};

/* ---------------- INITIALIZE APP ---------------- */
export const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

/* ---------------- SERVICES ---------------- */
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app, "gs://shineagrimscs.firebasestorage.app");


// ✅ If your functions are region-specific:
// Tumhare Tender Razorpay HTTP functions abhi default `us-central1` me deploy ho rahe hain.
// Agar callable functions bhi use karoge to region change yahan se kar sakte ho:
export const functions = getFunctions(app, "us-central1");

/* ---------------- AUTH PERSISTENCE ---------------- */
// Keep user signed in between reloads
setPersistence(auth, browserLocalPersistence).catch((err) =>
  console.warn("Auth persistence error:", err.code, err.message)
);

/* ---------------- UTILITIES ---------------- */

/**
 * Waits for Firebase to resolve current user state (logged in or not).
 * Usage:
 *   await authReady;
 *   if (auth.currentUser) ...
 */
export const authReady = new Promise((resolve) => {
  const unsub = onAuthStateChanged(auth, () => {
    unsub();
    resolve(true);
  });
});

/**
 * Checks if the currently signed-in user has the `admin` custom claim.
 * Returns true/false (forces token refresh).
 */
export async function getIsAdmin() {
  const u = auth.currentUser;
  if (!u) return false;
  try {
    const token = await u.getIdTokenResult(true);
    return !!token.claims?.admin;
  } catch (err) {
    console.warn("getIsAdmin() failed:", err.code || err.message);
    return false;
  }
}

/**
 * 🔹 Health Check: verify Firestore + Storage connectivity.
 * Returns an object { firestore: boolean, storage: boolean }
 * Call this once on startup if uploads ever hang at 0%.
 */
export async function firebaseHealthCheck() {
  const results = { firestore: false, storage: false };

  // --- Firestore health check (modular API) ---
  try {
    // NOTE: db.collection v9 me nahi hota, isliye yaha modular import use kar rahe hain
    const { collection, getDocs, limit } = await import("firebase/firestore");
    const colRef = collection(db, "_healthcheck");
    // thoda sa dummy read – agar collection empty bhi ho to query chal jayega
    await getDocs(limit ? limit(colRef, 1) : colRef);
    results.firestore = true;
  } catch (e) {
    console.error("⚠️ Firestore health-check failed:", e.message);
  }

  // --- Storage health check (same jaise tumhare code me hai) ---
  try {
    const blob = new Blob(["ok"], { type: "text/plain" });
    const { ref, uploadBytes, getDownloadURL } = await import(
      "firebase/storage"
    );
    const sRef = ref(storage, `career_healthchecks/test_${Date.now()}.txt`);
    await uploadBytes(sRef, blob);
    const url = await getDownloadURL(sRef);
    console.log("✅ Storage HealthCheck OK:", url);
    results.storage = true;
  } catch (e) {
    console.error("⚠️ Storage health-check failed:", e.message);
  }

  return results;
}

/**
 * 🔹 Refresh current user's token manually.
 * Useful after updating custom claims or when upload fails.
 */
export async function forceTokenRefresh() {
  try {
    if (auth.currentUser) {
      await auth.currentUser.getIdToken(true);
      console.log("✅ Token refreshed");
    }
  } catch (err) {
    console.error("⚠️ Token refresh failed:", err.message);
  }
}
